import * as React from 'react';
import {Field} from 'react-final-form';
import {mergeInputProps} from '@dnhb/functional-final-form';
import {FieldInputProps} from './types';
import {InputProps} from '../Textarea';
import Select from "../Select";

export type Props = InputProps & FieldInputProps<string>;

const SelectField = React.memo<any>((props) => (
    <Field<string>
        validateFields={[]}
        {...props}
        render={({input, meta}) => {
            const errors = [meta.error, meta.submitError, props.errors]
                .filter((error) => Array.isArray(error))
                .flat();
            return <Select emptyOption={false} clearKey={input.name} label={''}
                           readOnly={false} {...mergeInputProps(input, props)}
                           errors={errors.length && (!meta.submitError || !meta.dirtySinceLastSubmit)
                               ? errors
                               : null}/>
        }}
    />
));

export default SelectField;
